import { useState } from 'react';
import { env } from '@/utils/env';
import { Warning, Close } from '@carbon/icons-react';

const ENV_CONFIG = {
  staging: {
    label: 'STAGING',
    message: 'Test data only',
    background: 'var(--warning-dark-2)',
  },
  development: {
    label: 'DEV',
    message: 'Local development environment',
    background: 'var(--info-dark-1)',
  },
} as const;

export function EnvironmentBanner() {
  const nodeEnv = env?.VITE_NODE_ENV;
  const [isDismissed, setIsDismissed] = useState(false);

  if (!nodeEnv || nodeEnv === 'production' || isDismissed) return null;

  const config = ENV_CONFIG[nodeEnv as keyof typeof ENV_CONFIG];
  if (!config) return null;

  return (
    <div
      role="status"
      aria-label={`${config.label} environment indicator`}
      style={{
        width: '100%',
        backgroundColor: config.background,
        color: 'var(--white)',
        padding: '6px 16px',
        fontSize: '13px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        flexShrink: 0,
        position: 'relative',
      }}
    >
      <Warning size={16} />
      <span
        style={{
          background: 'var(--neutral-light-2)',
          color: 'var(--neutral-dark-2)',
          borderRadius: '4px',
          padding: '1px 7px',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.07em',
        }}
      >
        {config.label}
      </span>
      <span>{config.message}</span>
      <button
        onClick={() => setIsDismissed(true)}
        aria-label="Dismiss environment banner"
        style={{
          position: 'absolute',
          right: '12px',
          background: 'var(--neutral-light-1)',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          color: 'var(--neutral-dark-2)',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Close size={14} />
      </button>
    </div>
  );
}
